import { customAxios } from "@/shared/lib/customAxios"
import type { ListRequest, ListResponse } from "@/shared/types/commonResponse"
import {
  useInfiniteQuery,
  useQuery,
  type UseQueryResult,
} from "@tanstack/react-query"

// POST /star/video/list  ------------------------------ Video List

export interface VideoContent {
  id: number
  starId: number
  title: string
  thumbImageUrl: string
  videoUrl: string
  regDt: string
}

export type VideoListResponse = ListResponse<VideoContent>

const videoList = ({
  Language,
  requestDto,
  angkorId,
}: ListRequest): Promise<VideoListResponse> => {
  return customAxios
    .post<VideoListResponse>("star/video/list", requestDto, {
      headers: {
        Language: Language,
        angkorId: angkorId,
      },
    })
    .then((res) => res.data)
}

export const useVideoListQuery = (
  request: ListRequest,
  options?: { enabled?: boolean }
): UseQueryResult<VideoListResponse, Error> => {
  return useQuery<VideoListResponse, Error>({
    queryKey: ["videoList", request],
    queryFn: () => videoList(request),
    gcTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    enabled: options?.enabled,
  })
}

// POST /star/video/list  ------------------------------ Video List

const PAGE_SIZE = 5

export const useVideoInfiniteQuery = (
  baseRequest: Omit<ListRequest, "requestDto"> & {
    requestDto: Omit<ListRequest["requestDto"], "pageable">
  }
) => {
  return useInfiniteQuery<VideoListResponse, Error>({
    queryKey: ["videoInfiniteList", baseRequest],
    queryFn: ({ pageParam = 1 }) =>
      videoList({
        ...baseRequest,
        requestDto: {
          ...baseRequest.requestDto,
          pageable: {
            page: pageParam as number,
            size: PAGE_SIZE,
            sort: [],
          },
        },
      }),
    // getNextPageParam: 마지막 페이지 여부에 따라 다음 page 반환
    getNextPageParam: (lastPage) => {
      return lastPage.isLast ? undefined : lastPage.currentPage + 1
    },
    initialPageParam: 1,
  })
}
